import { Connection } from '@solana/web3.js'

if (!import.meta.env.VITE_RPC_ENDPOINT) throw new Error('VITE_RPC_ENDPOINT is not defined in app .env file')
const connection = new Connection(import.meta.env.VITE_RPC_ENDPOINT)

export const useRPCConnection = () => {
    return connection
}
